import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { FiMoreHorizontal } from "react-icons/fi";
import { withRouter } from "react-router-dom";
import { TabletOrDesktop, Mobile } from "utils/responsive";
import { Dropdown } from "react-bootstrap";
import StoreFolderEdit from "components/Documents/StoreFolderEditModal";
import { showModal, hideModal } from "actions/modalActions";
import { storeFoldersActions } from "actions/storeFoldersActions";
import { documentsService } from "services";
import { errorFormating } from "utils/utils";
import { withTranslation } from "react-i18next";

class StoreFoldersList extends Component {
	constructor(props) {
		super(props);
		// console.log(props);

		this.closeModal = this.closeModal.bind(this);
	}

	closeModal() {
		this.props.hideModal();
	}

	openEditStoreFolderModal(store_folder) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("documents.folder.edit"),
				style: { width: "400px" },
				content: (
					<StoreFolderEdit
						store_folder={store_folder}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openViewStoreFolderPage(store_folder) {
		this.props.history.push("/store-folders/" + store_folder.id);
	}

	openDeleteStoreFolderModal(idFolder) {
		const { t } = this.props;
		this.props.showModal(
			{
				open: true,
				title: t("documents.folder.delete"),
				message: t("documents.folder.deleteConfirmGeneric"),
				deleteAction: () => this.confirmDelete(idFolder),
				closeModal: this.closeModal,
			},
			"delete"
		);
	}

	openAlertModal(message) {
		const { t } = this.props;
		this.props.showModal(
			{
				open: true,
				title: t("common.error"),
				style: { width: "400px" },
				message: message,
				closeModal: this.closeModal,
			},
			"alert"
		);
	}

	confirmDelete = async (idFolder) => {
		try {
			await documentsService.deleteStoreFolder(idFolder);
			this.props.getStoreFolders();
			this.closeModal();
		} catch (error) {
			let textError = errorFormating(error);
			this.openAlertModal(
				textError.id || this.props.t("documents.folder.deleteError")
			);
		}
	};

	getEmptyRow = () => {
		return (
			<tr>
				<td colSpan="5" className="no-result">
					{this.props.t("documents.folder.noFolders")}
				</td>
			</tr>
		);
	};

	getRows = (isMobile) =>
		this.props.store_folders.map((store_folder) => {
			// console.log(store_folder);
			return (
				<tr key={store_folder.id}>
					<td>
						<button
							className="btn-transparent btn-editable folder-name"
							onClick={() => this.openEditStoreFolderModal(store_folder)}
						>
							{store_folder.name}
						</button>
					</td>
					<td className="td-actions">{this.getActions(store_folder)}</td>
				</tr>
			);
		});

	getActions = (store_folder) => {
		const { t } = this.props;
		return (
			<Dropdown>
				<Dropdown.Toggle variant="action">
					<FiMoreHorizontal />
				</Dropdown.Toggle>
				<Dropdown.Menu>
					<Dropdown.Item
						as="button"
						onClick={() => this.openViewStoreFolderPage(store_folder)}
					>
						{t("common.view")}
					</Dropdown.Item>
					<Dropdown.Item
						as="button"
						onClick={() => this.openEditStoreFolderModal(store_folder)}
					>
						{t("common.edit")}
					</Dropdown.Item>
					<Dropdown.Item
						as="button"
						onClick={() => this.openDeleteStoreFolderModal(store_folder.id)}
					>
						{t("common.delete")}
					</Dropdown.Item>
				</Dropdown.Menu>
			</Dropdown>
		);
	};

	render() {
		return (
			<>
				<Mobile>
					<div className="table-mobile-container">
						<table className="table table-folders table-mobile">
							<tbody>
								{this.props.store_folders.length === 0
									? this.getEmptyRow()
									: this.getRows(true)}
							</tbody>
						</table>
					</div>
				</Mobile>
				<TabletOrDesktop>
					<table className="table table-folders table-zebra">
						<thead>
							<tr>
								<th>{this.props.t("documents.folder.nameColumn")}</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							{this.props.store_folders.length === 0
								? this.getEmptyRow()
								: this.getRows(false)}
						</tbody>
					</table>
				</TabletOrDesktop>
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return reducers.storeFoldersReducer;
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	getStoreFolders: (options) =>
		dispatch(storeFoldersActions.getStoreFolders(options)),
});

export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps),
	withTranslation()
)(StoreFoldersList);
